/* Default Appstle's PDP widget to the Monthly plan and keep the badge at SAVE 10%.
   Appstle sets subscriptionOptionSelectedByDefault to false, so One Time starts checked.
   The Monthly plan's first-order discount is 10%. A 15% label is not offered. */
(function () {
  if (!document.body || !document.body.classList.contains('product')) return;

  var userPicked = false;
  var applying = false;
  var attempts = 0;

  function labelText(input) {
    if (!input) return '';
    var label = input.id
      ? document.querySelector('label[for="' + CSS.escape(input.id) + '"]')
      : null;
    return ((label && label.textContent) || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function scorePlan(input) {
    if (!input || !input.value) return -1;
    var text = labelText(input).toLowerCase();
    if (/2\s*weeks?/.test(text)) return -1;
    var score = 1;
    if (/monthly/.test(text)) score += 5;
    if (/10\s*%/.test(text)) score += 3;
    if (/15\s*%/.test(text) && !/10\s*%/.test(text)) score -= 4;
    return score;
  }

  function scrubFifteen(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue;
      if (!value || value.indexOf('15') === -1) continue;
      if (/\$\s*15/.test(value)) continue;
      if (!/15\s*%/.test(value)) continue;
      if (!/(%|save|off|discount)/i.test(value)) continue;
      node.nodeValue = value
        .replace(/up\s+to\s+15\s*%/gi, 'SAVE 10%')
        .replace(/15\s*%/g, '10%');
    }
  }

  function selectMonthly(root) {
    if (userPicked || applying || attempts > 8) return;
    var inputs = root.querySelectorAll('input[name="selling_plan"]');
    if (!inputs.length) return;

    var best = null;
    var bestScore = -1;
    inputs.forEach(function (input) {
      var score = scorePlan(input);
      if (score > bestScore) {
        best = input;
        bestScore = score;
      }
    });
    scrubFifteen(root);
    if (!best || bestScore < 1) return;
    if (best.checked) return;

    applying = true;
    attempts += 1;
    best.checked = true;
    best.dispatchEvent(new Event('input', { bubbles: true }));
    best.dispatchEvent(new Event('change', { bubbles: true }));
    best.click();
    applying = false;
    scrubFifteen(root);
  }

  function scan() {
    document
      .querySelectorAll('#appstle_subscription_widget0, .appstle_sub_widget')
      .forEach(selectMonthly);
  }

  document.addEventListener(
    'change',
    function (event) {
      if (applying) return;
      var target = event.target;
      if (target && target.name === 'selling_plan') userPicked = true;
    },
    true
  );

  var queued = false;
  var observer = new MutationObserver(function () {
    if (queued || userPicked) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  });

  function start() {
    scan();
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
